export default __webpack_public_path__ + "static/cruiselines-carnival-activities-3-0f8b8f9b58ac5034bc2a79927d2cedcf.jpg";